import agendaData2024 from './2024'
import agendaData2025 from './2025'

export const agendaData = {
  2024: agendaData2024,
  2025: agendaData2025,
}
